



















































import { Component, Prop, Vue } from "vue-property-decorator";
import { Product } from "../types/DataSource";
import Headline from "./Headline.vue";
import ProductItem from "./ProductItem.vue";

@Component({
  components: {
    Headline,
    ProductItem
  }
})
export default class ProductList extends Vue {
  @Prop() private products!: Product[];

  private productSortType = "sort-by-relevance-asc";

  get otherRecommendedProducts() {
    const productsExceptTop = this.products;

    switch (this.productSortType) {
      case "sort-by-relevance-asc":
        return productsExceptTop;

      case "sort-by-relevance-desc": {
        return [...productsExceptTop].reverse();
      }

      case "sort-by-price-asc":
        return [...productsExceptTop].sort(
          (product1, product2) => product1.price - product2.price
        );

      case "sort-by-price-desc":
        return [...productsExceptTop].sort(
          (product1, product2) => product2.price - product1.price
        );
    }

    return productsExceptTop;
  }

  get customVuexStyles() {
    return {
      "--font-main": this.$store.state.globalCss.font.fontName,
      "--headline-color": this.$store.state.globalCss.colors.headline.color
    };
  }
}
